// Replaced by AuthModal
export default function LoginPage() { return null; }
